export type Dimension = 'x' | 'y';

export interface PlacementRect {
    top: number;
    left: number;
    width?: number;
    height?: number;
}

export interface Alignment {
    top?: number;
    left?: number;
}
